(function() {
  'use strict';

  function ImporterTasksService(EasApiStore, EasApi) {
    var service = new EasApiStore('importer');
    var apiVersion = 'v2';

    service.getAvailableEventTypes = function(action) {
      var url = service.listUrl() + 'event/available-event-types/' + action;
      return EasApi.get(url, {}, {}, { version: apiVersion });
    };

    service.getAvailableBookingItems = function() {
      var url = service.listUrl() + 'booking/available-booking-items';
      return EasApi.get(url, {}, {}, { version: apiVersion });
    };

    service.importerSearchOrigin = function(originId, state) {
      var url = service.listUrl() + 'search/origin/' + originId;
      if (state) {
        url += '/' + state;
      }
      return EasApi.get(url, {}, {}, { version: apiVersion });
    };

    return service;
  }

  ImporterTasksService.$inject = ['EasApiStore', 'EasApiService'];

  angular.module('blocks.asyncTasks')
    .factory('ImporterTasksService', ImporterTasksService);
})();
